<template>
  <h3-list-item :className="wrapCls" :hasThumb="true" :multipleLine="multipleLine" :brief="listBrief" :disabled="disabled" @onClick="onInnerClick" :hasContentLine="false">
    <h3-checkbox
      slot="thumb"
      ref="checkbox"
      @onClick="onInnerClick"
      @onChange="onInnerChange"
      :name="name"
      :id="id"
      :readOnly="readOnly"
      :disabled="disabled"
      :checked="!!checked"
      :value="value"
      :warpLabel="true"
      :returnValue="returnValue"
      :options="options"
    ></h3-checkbox>
    <template slot="brief" v-if="listBrief">
      <slot name="list-item-brief"></slot>
    </template>
    <slot></slot>
  </h3-list-item>
</template>

<script>
import cx from "classnames";
import H3Checkbox from "./h3-checkbox";
// import { H3ListItem } from "../../components/h3-list/";
import { H3ListItem } from "h3-mobile-vue";

const prefixCls = "h3-checkbox";
export default {
  name: "h3-checkbox-item",
  components: {
    H3Checkbox,
    H3ListItem,
  },
  props: {
    className: String,
    h3style: Object,
    name: String,
    id: String,
    defaultChecked: {
      type: [Number, Boolean],
      default: false,
    },
    multipleLine: Boolean,
    checked: [Number, Boolean],
    disabled: Boolean,
    onClick: Function,
    tabIndex: String,
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: String,
    wrapLabel: {
      type: Boolean,
      default: true,
    },
    returnValue: {
      type: Array,
      default() {
        return [];
      },
    },
    listBrief: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
    },
  },
  watch: {},
  data() {
    return {
      innerChecked: this.checked,
      innerValue: "",
    };
  },
  methods: {
    onInnerClick() {
      this.$emit("onClick", this.innerValue);
    },
    onInnerChange(val, check) {
      this.innerChecked = check;
      this.innerValue = val;
      this.$emit("onChange", val, check);
    },
  },
  computed: {
    wrapCls() {
      return cx(`${prefixCls}-item`, this.className, {
        [`${prefixCls}-item-disabled`]: this.disabled === true,
      });
    },
  },
};
</script>
<style lang="less">
@import "../../styles/mixins";
.h3-list-item.h3-checkbox-item .h3-list-line .h3-list-content {
  text-overflow: unset !important;
  white-space: normal !important;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 17px;
  line-height: 25px;
  box-sizing: border-box;
}
.h3-checkbox-item {
  padding-left: 0px !important;
  min-height: 45px;
  &.h3-checkbox-item .h3-list-thumb {
    // width: 11px;
    // height: 11px;
  }
  &.h3-checkbox-item .h3-list-thumb .h3-checkbox {
    .px2rem(min-height, 90);
    min-height: 45px;
  }
  .h3-list-content {
    .px2rem(min-height, 90);
    min-height: 45px;
  }
}
.h3-list .h3-list-body .h3-list-item.h3-checkbox-item .h3-list-thumb .h3-checkbox-inner {
  left: 0;
  top: 11px;
}
</style>
